import React, { useState, useEffect, useCallback } from "react";
import { fetchAllPosts } from "../../http/http-calls";
import "./MonitoringPage.css";
import { convertUrlToCdn } from "../../helper-methods";
const MonitoringPage = () => {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({
    status: "all",
    searchTerm: "",
  });

  const ITEMS_PER_PAGE = 10;

  const fetchPosts = useCallback(async () => {
    try {
      const response = await fetchAllPosts({
        page: page,
        status: filters.status,
        search: filters.searchTerm,
      });

      setPosts(response?.posts);
      setTotalPages(Math.ceil(response?.total / ITEMS_PER_PAGE));
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  }, [page, filters]);

  useEffect(() => {
    fetchPosts();
  }, [page, filters, fetchPosts]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleFilterChange = (event) => {
    setFilters({
      ...filters,
      [event.target.name]: event.target.value,
    });
    setPage(1);
  };

  return (
    <div className="container">
      <div className="filter-grid">
        <input
          type="text"
          name="searchTerm"
          placeholder="Search posts..."
          value={filters.searchTerm}
          onChange={handleFilterChange}
          className="input-field"
        />
        <select
          name="status"
          value={filters.status}
          onChange={handleFilterChange}
          className="input-field"
        >
          <option value="all">All Posts</option>
          <option value="active">Active</option>
          <option value="archived">Archived</option>
        </select>
      </div>

      <div className="posts-container">
        {posts.map((post) => (
          <div key={post.id} className="post-card">
            <div className="user-info">
              <div>
                <h4 className="user-name">{post.user.fullname}</h4>
                <span className="post-date">
                  {new Date(post.createdAt).toLocaleDateString()}
                </span>
              </div>
            </div>

            <div dangerouslySetInnerHTML={{ __html: post.caption }} />

            {post.group && (
              <div className="group-info">Posted in: {post.group.name}</div>
            )}

            {post.isLiveEventPost && post.liveEventDetails && (
              <div className="live-event">
                <h4 className="user-name">Live Event</h4>
                <p>Title: {post.liveEventDetails.title}</p>
                <p>
                  Date:{" "}
                  {new Date(post.liveEventDetails.liveDate).toLocaleString()}
                </p>
                <p>Time Zone: {post.liveEventDetails.timeZone}</p>
                <p>
                  Status:{" "}
                  {post.liveEventDetails.isStarted ? "Started" : "Not Started"}
                </p>
              </div>
            )}

            {post.mediaDetails && post.mediaDetails.length > 0 && (
              <div className="media-container">
                {post.mediaDetails.map((media, index) => {
                  switch (media.contentType?.toLowerCase()) {
                    case "image":
                      return (
                        <img
                          key={index}
                          src={convertUrlToCdn(media.mediaUrl)}
                          alt={post.caption}
                          className="media-image"
                        />
                      );
                    case "video":
                      return (
                        <video key={index} controls className="media-video">
                          <source
                            src={convertUrlToCdn(media.mediaUrl)}
                            type="video/mp4"
                          />
                          Your browser does not support video playback.
                        </video>
                      );
                    case "audio":
                      return (
                        <audio key={index} controls className="media-audio">
                          <source
                            src={convertUrlToCdn(media.mediaUrl)}
                            type="audio/mpeg"
                          />
                          Your browser does not support audio playback.
                        </audio>
                      );
                    default:
                      return null;
                  }
                })}
              </div>
            )}

            <div className="post-metadata">
              <span>💬 {post.commentCount} Comments</span>
              <span>❤️ {post.reactionCount} Reactions</span>
              {post.isPaid && (
                <span className="paid-content">Paid Content</span>
              )}
              {post.isPinPost && <span>📌 Pinned</span>}
            </div>
          </div>
        ))}
      </div>

      <div className="pagination">
        <button
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 1}
          className="pagination-button"
        >
          Previous
        </button>
        <span className="pagination-text">
          Page {page} of {totalPages}
        </span>
        <button
          onClick={() => handlePageChange(page + 1)}
          disabled={page === totalPages}
          className="pagination-button"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default MonitoringPage;
